var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 15.9375C8.85242 15.9375 8.52884 15.9375 8.375 15.9375C7 15.9375 4.25 15.2885 4.25 11.8269C4.25 9.05769 6.69444 7.78846 7.91667 7.5C7.91667 7.5 8.83333 4.6875 12.5 4.6875C16.1667 4.6875 17.5417 7.71635 17.5417 9.01442C18.6875 9.01442 20.75 9.87981 20.75 12.2596C20.75 15.0721 18.4583 15.9375 17.0833 15.9375C16.2603 15.9375 15.8658 15.9375 14.75 15.9375",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2654 9.29277L9.88954 12.2625C9.7324 12.459 9.87225 12.7499 10.1238 12.7499H11.6988V19.6799C11.6988 19.8567 11.8421 19.9999 12.0188 19.9999H12.9788C13.1556 19.9999 13.2988 19.8567 13.2988 19.6799V12.7499H14.8754C15.127 12.7499 15.2668 12.459 15.1097 12.2625L12.7339 9.29277C12.6138 9.14265 12.3855 9.14265 12.2654 9.29277Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.71db9a3e529b7babb365633bbd2dea6a.svg";
export { ForwardRef as ReactComponent };